import React from 'react'
import logo from '../../assets/images/vi_premium_update_logo.png'
const PremiumTextLogo = () => {
  return (
    <div className='d-flex justify-content-center flex-column align-items-center my-4 logo'>
        <span>
        {/* <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M72.4261 13.9172V16.8522H71.7649V13.9172H70.7031V13.3462H73.4829V13.9172H72.4261ZM74.4832 14.5282V16.8522H73.8672V13.3462H74.6285L75.6903 15.9356L76.7521 13.3462H77.5134V16.8522H76.8974V14.5282L75.9407 16.8522H75.4399L74.4832 14.5282Z" fill="#FEFEFE"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M54.323 52.7652H68.403V13.3335H54.323V52.7652ZM35.6435 13.3335L26.5286 50.0767L17.4136 13.3335H3.33337L13.1153 52.7652H39.9419L49.7237 13.3335H35.6435Z" fill="white"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M69.027 64.9813C69.027 69.1991 65.5956 72.6185 61.3625 72.6185C57.1295 72.6185 53.6979 69.1991 53.6979 64.9813C53.6979 60.7633 57.1295 57.3438 61.3625 57.3438C65.5956 57.3438 69.027 60.7633 69.027 64.9813Z" fill="#FFC600"/>
</svg> */}
        <img src={logo} style={{    width: '16rem', }}/>
        </span>
{/* <h1 className='active'>PREMIUM</h1> */}
    </div>
  )
}

export default PremiumTextLogo